module.exports = __webpack_public_path__ + "components/country-flag/static/ge-0d4392778f344e3c250c8b2a0abfd1b2.svg";